import { motion } from "framer-motion";

const CHECKS = [
  {
    title: "Continuous Vulnerability Scanning",
    desc: "Automated identification of CVEs across your entire perimeter.",
  },
  {
    title: "Detecting Shadow IT",
    desc: "Find untracked assets and forgotten infrastructure instantly.",
  },
  {
    title: "Prioritized Risk Alerts",
    desc: "Focus on critical exploits, not noise.",
  },
];

const FEED = [
  { severity: "High", text: "Exposed Admin Panel detected on sub.example.com", time: "Just now" },
  { severity: "Medium", text: "Outdated TLS Configuration found", time: "2m ago" },
  { severity: "Low", text: "Port Scan Detected originating from 192.168.x.x", time: "15m ago" },
];

const SEVERITY_STYLE = {
  High: "bg-error-container text-on-error-container",
  Medium: "bg-severity-warning/20 text-severity-warning",
  Low: "bg-severity-good/20 text-severity-good",
};

export default function AsmStory() {
  return (
    <section className="py-section-gap px-margin-mobile md:px-gutter max-w-container-max mx-auto">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-gutter items-center">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.55 }}
          className="space-y-stack-lg"
        >
          <h2 className="font-headline-section text-headline-section text-on-surface dark:text-surface-bright">
            Address weaknesses before they're exploited
          </h2>
          <div className="space-y-stack-md">
            {CHECKS.map((c) => (
              <div
                key={c.title}
                className="flex items-start gap-3 bg-surface-card-light dark:bg-surface-card-dark backdrop-blur-lg border border-glass rounded-xl p-card-padding"
              >
                <span className="material-symbols-outlined text-severity-good mt-1">check_circle</span>
                <div>
                  <h3 className="font-headline-card text-headline-card text-on-surface dark:text-surface-bright">
                    {c.title}
                  </h3>
                  <p className="font-body-md text-body-md text-on-surface-variant dark:text-surface-variant">
                    {c.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.55, delay: 0.1 }}
          className="bg-surface-dark rounded-xl border border-glass p-card-padding relative overflow-hidden shadow-2xl h-[500px] flex flex-col"
        >
          <div className="absolute inset-0 bg-gradient-to-b from-transparent to-primary-container/10 pointer-events-none" />
          <div className="absolute top-0 left-0 w-full h-[2px] bg-primary-container animate-scan opacity-50 shadow-[0_0_15px_rgba(249,115,22,0.8)]" />
          <div className="flex items-center justify-between mb-stack-lg z-10 border-b border-glass pb-4">
            <h3 className="font-headline-card text-headline-card text-surface-bright flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-severity-critical animate-pulse" />
              Live Signal Feed
            </h3>
            <span className="font-data-mono text-data-mono text-tertiary-fixed-dim">Scanning...</span>
          </div>
          <div className="flex-1 overflow-y-auto space-y-stack-sm z-10 pr-2">
            {FEED.map((item) => (
              <div
                key={item.text}
                className="bg-white/5 border border-white/10 rounded-lg p-4 hover:bg-white/10 transition-colors"
              >
                <div className="flex justify-between items-start mb-2">
                  <span className={`font-data-mono text-label-sm px-2 py-1 rounded-sm uppercase tracking-wider ${SEVERITY_STYLE[item.severity]}`}>
                    {item.severity}
                  </span>
                  <span className="font-data-mono text-label-sm text-tertiary-fixed-dim">{item.time}</span>
                </div>
                <p className="font-body-md text-body-md text-surface-bright">{item.text}</p>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
